import React from "react";
import EtLogoutIcon1SVGComp from "@/assets/img/icons/svgComp/EtLogoutIcon1SVGComp";
import EtLogo from "@/assets/images/EtLogo2.png";

const EtWebAdminTopBar = ({ name, handleLogout }) => {

  // First Created - 29 Nov 2025
  // Author - Atul Pandey  

  return (
    <div className="bg-white shadow-md rounded p-3 py-5 flex items-center justify-between">

      {/* Logo + Title */}
      <div className="flex items-center gap-3">
        <img src={EtLogo} alt="Eternity" className="h-7 w-auto" />
        <h1 className="text-xl font-bold text-gray-800">
          Trinity Web Admin Dashboard
        </h1>
      </div>

      {/* User Info */}
      <div className="flex items-center gap-4">

        <p className="text-sm text-gray-700">
          Hello <span className="text-black font-semibold">{name}</span>
        </p>

        {/* Logout */}
        <div 
          onClick={handleLogout}
          className="cursor-pointer relative group"
        >
          <div className="flex justify-center items-center rounded-full w-6 h-6 bg-gradient-to-r from-orange-800 to-orange-600 shadow">
            <EtLogoutIcon1SVGComp className="h-3 w-3 text-white" />
          </div>
          <div className="absolute bottom-7 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition">
            Logout
          </div>
        </div>

      </div>

    </div>
  );
};

export default EtWebAdminTopBar;